// extracted by mini-css-extract-plugin
export var hsButton = "hs-button-hs-module--hs-button--c6ed4";
export var icon = "hs-button-hs-module--icon--3ea3d";
export var iconBack = "hs-button-hs-module--icon-back--af0d9";
export var iconClose = "hs-button-hs-module--icon-close--25461";
export var iconDelete = "hs-button-hs-module--icon-delete--d23eb";
export var iconPlus = "hs-button-hs-module--icon-plus--e467a";
export var primary = "hs-button-hs-module--primary--0460e";
export var secondary = "hs-button-hs-module--secondary--3ed92";
export var sizeLarge = "hs-button-hs-module--size-large--d1648";
export var sizeSmall = "hs-button-hs-module--size-small--5bcdf";
export var sizeStandard = "hs-button-hs-module--size-standard--5b63b";